<template>
  <v-container>
    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <library-modal></library-modal>
      <v-menu
        v-model="addDropDownMenu"
        :close-on-content-click="false"
        left
        :nudge-left="importNewModal ? 100 : 0"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            ref="addResourceBtn"
            v-if="userCanEdit && userIsWorkspaceMember"
            v-on="on"
            @click="importNewModal = false"
            text
          >
            <v-icon class="mr-2">add</v-icon>Add
          </v-btn>
        </template>
        <v-list v-if="!importNewModal">
          <v-list-item
            @click="
              browseModal = true;
              addDropDownMenu = false;
            "
          >
            Browse Resources
          </v-list-item>
          <v-list-item @click="importNewModal = true">
            Import New Resource
          </v-list-item>
        </v-list>
        <add-resource-widget
          v-else
          @created="
            addDropDownMenu = false;
            importNewModal = false;
          "
        ></add-resource-widget>
      </v-menu>
    </v-row>
    <template v-for="category in resourcesByCategory">
      <v-row :key="category.id">
        <h2>{{ category.name }}</h2>
        <v-data-iterator
          class="row"
          style="overflow-y: auto;"
          :items="category.research"
          :search="search"
          :custom-filter="filterItems"
          :sort-by="sortBy.toLowerCase()"
          :sort-desc="false"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:default="props">
            <template v-for="item in props.items">
              <v-col cols="3" :key="item.id">
                <resource-details-card showOpen :resource="item"></resource-details-card>
              </v-col>
            </template>
          </template>
        </v-data-iterator>
      </v-row>
    </template>
    
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

import ImportResourceModal from '../../ResourcePanel/ImportResourceModal';
import AddResourceWidget from '@/components/Resources/AddResourceWidget';
import LibraryModal from '@/views/Context/components/LibraryModal';

import ResourceDetailsCard from '@/components/Resources/ResourceDetailsCard';

export default {
  props: ['thisPageId'],
  data() {
    return {
      search: null,
      searchExcerpts: false,
      itemsPerPageArray: [4, 8, 12],
      page: 1,
      itemsPerPage: 4,
      sortBy: 'name',
      browseModal: false,
      importNewModal: false,
      addDropDownMenu: false,
    };
  },
  components: {
    LibraryModal,
    AddResourceWidget,
    ResourceDetailsCard
  },
  computed: {
    ...mapState('pages', ['pages']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapGetters('context', ['context', 'userIsWorkspaceMember', 'userCanEdit']),
    ...mapGetters('pages', ['selectedPageNotes']),
    ...mapState('resources', ['resources']),
    ...mapGetters('resources', ['resourcesByCategory']),
    items() {
      return Object.values(this.resources).filter(r => !!r.usedOn[this.context.id]);
    }
  },
  methods: {
    ...mapMutations('views/context', ['setSelectedPageId']),
    ...mapActions('context', ['addQuestion', 'updateQuestionText']),
    filterItems(items, search) {
      this.filteredExcerpts = {};
      if (search == null) return items;
      const filtered = [];
      items.forEach(item => {
        try {
          const i = item; // make a clone
          const { title, description, provider } = i.resourceData;
          const tags = i.tags.userDefined;
          const tagString = Object.values(tags)
            .map(t => t.text)
            .toString();
          const searchableString = `${i.text ? i.text : ''} ${title ? title : ''} ${
            description ? description : ''
          } 
          ${provider ? provider : ''} ${tagString}`;
          let found = false;
          if (searchableString.toLowerCase().includes(search.toLowerCase())) {
            filtered.push(i);
            found = true;
          }
          if (this.searchExcerpts && search.length > 1) {
            this.filteredExcerpts[i.id] = [];
            const excerpts = Object.values(i.noteBlocks).filter(
              n => n.content.widgetType == 'textExcerpt' && !n.toDelete
            );
            excerpts.forEach(e => {
              if (e.content.widgetData.excerpt.toLowerCase().includes(search.toLowerCase())) {
                if (!found) {
                  filtered.push(i);
                  found = true;
                }
                this.filteredExcerpts[i.id].push(e);
              }
            });
          } else {
            this.fitleredExcerpts = {};
          }
        } catch (e) {
          console.log(e);
        }
      });
      return filtered;
      // search = search.toString().toLowerCase();
      // return items.filter(i => Object.keys(i).some(j => filter(i[j], search)));
    },
    async createNewItem() {
      if (!this.userCanEdit) {
        return;
      }
      //  If we are making a child, put it at the end of the children, otherwise put right below this one.
      const args = { text: '', order: this.questions.length, type: 2 };
      // if (!this.showChildren) {
      //   this.toggleChildren();
      // }
      const id = await this.addQuestion(args);
      this.$nextTick(() => {
        //this.selected = id;
        //this.$emit('focusEdit', id);
        this.$refs[`editor-${id}`][0].focus();
      });
    }
  }
};
</script>

<style></style>
